export default
{
	fieldEmCheck:
	{
		settings:
		{
			checked_status_in_db: 'Checked status in DB',
			unchecked_status_in_db: 'Unchecked status in DB',
			enter_checked_string: 'Enter checked string',
			enter_unchecked_string: 'Enter unchecked string',
		}
	},
	fieldEmDate:
	{
		settings:
		{
			include_time: 'Include Time',
		}
	},
	fieldEmFile:
	{
		settings:
		{
			folder_for_save: 'Folder for save',
			resolutions: 'Resolutions',
			width: 'Width',
			height: 'Height',
			add_resolution: 'Add resolution',
		},
		no_files: 'No files',
		add_file: 'Add file',
		choose_file: 'Choose File',
		embed_link: 'Embed Link',
	},
	fieldEmList:
	{
		settings:
		{
			key: 'Key',
			value: 'Value',
			add_option: 'Add option',
			enter_key: 'Enter key',
			enter_value: 'Enter value',
		}
	},
	fieldEmNode:
	{
		settings:
		{
			node_field: 'Node field',
			search_field: 'Search field',
			select_field: 'Select field',
			select_table: 'Select table'
		}
	},
	fieldEmMatrix:
	{
		settings:
		{
			key_field: 'Key field',
			select_field: 'Select field',
			select_table: 'Select table',
			node_table: 'Node table',
			many_to_many: 'Many to many'
		},
	},
	fieldEmInteger:
	{
		settings:
		{
			min_max: 'Min must be less than max',
		},
		min_max_error: 'Incorrect value. Min is: {min}, max is: {max}',
	},
	forms:
	{
		list:
		{
			search_for_an_option: 'Search for an option...',
		},
		loader:
		{
			loading: 'Loading...'
		}
	},
	pagination:
	{
		elements_per_page: 'Elements per page - ',
	},
	settingsLang:
	{
		select_language: 'Select Language:',
	},
	settingsTable:
	{
		no_tables: 'No tables',
	},
	sidebar:
	{
		extensions: 'Extensions',
		settings_and_users: 'Settings & Users',
	},
	tviews:
	{
		empty_table: 'Empty Table',
	},
	pages:
	{
		settings:
		{
			user_and_table_settings: 'User & table settings',
		},
		update:
		{
			check_and_update_element: 'Check and update element',
			current_version: 'Current version:',
			you_have_the_latest_version: 'You have the latest version',
			system_has_been_updated_successfully: 'System has been updated successfully',
			check_version: 'Check version',
			update_to: 'Update to',
		},
		table:
		{
			edit_element: 'Edit element',
			new_element: 'New Element',
		}
	},
	auth:
	{
		forgot_your_password: 'Forgot your password?',
		log_in: 'Log In',
		forgot_password: 'Forgot password',
		reset_password: 'Reset Password',
		return_to_log_in_page: 'Return to Log In page?',
		new_password_was_sended_to_your_email: 'New password was sended to your email.',
		enter_your_login_or_email: 'Enter your login or email',
		enter_your_password: 'Enter your password',
		enter_your_email: 'Enter your Email',
		incorrect_login: 'Incorrect login',
		incorrect_password: 'Incorrect password',
		incorrect_email: 'Incorrect email',
		incorrect_login_or_password: 'Incorrect login or password',
		empty_email: 'Empty email',
		invalid_email_format: 'Invalid email format',
	},
	popups:
	{
		filtersPopup:
		{
			add_filter: 'Add filter',
		},
		sortPopup:
		{
			add_sort: 'Add sort',
			asc: 'Ascenging',
			desc: 'Descending',
		},
		confirmCloseButtons:{
			close:'Are you sure you want to close popup?',
			confirm_close: 'Close',
			cancel: 'Cancel'
		},
		confirmDeletePopup:
		{
			remove: 'Are you sure you want to delete this item permanently?',
			removeSelected: 'Are you sure you want to delete this items permanently?',
			confirm_delete: 'Delete',
			cancel: 'Cancel',
		},
		addUser:
		{
			this_field_required: 'This field required'
		},
	},
	yes: 'Yes',
	no: 'No',
	remove: 'Remove',
	delete: 'Delete',
	edit: 'Edit',
	duplicate: 'Duplicate',
	upload: 'Upload',
	upload_by_link: 'Upload ly link',
	select_an_option: 'Select an Option',
	value: 'Value',
	empty: 'Empty',
	table: 'Table',
	tables: 'Tables',
	languages: 'Languages',
	groups: 'Groups',
	users: 'Users',
	developed_by: 'Developed by',
	cancel: 'Cancel',
	save_settings: 'Save settings',
	clear: 'Clear',
	paste_link: 'Paste link',
	code: 'Code',
	name: 'Name',
	name2: 'Name',
	show: 'Show',
	settings: 'Settings',
	settings_of: '{of_what} Settings',
	login: 'Login',
	set_something: 'Set ',
	password: 'Password',
	update: 'Update',
	log_out: 'log out',
	save: 'Save',
	create: 'Create',
	properties: 'Properties',
	sort: 'Sort',
	filter: 'Filter',
	add_element: 'Add Element',
	add_user: 'Add user',
	add: 'Add',
	enter_something: 'Enter ',
	key: 'Key',
	createGroup: 'Create Group',
	addGroup: 'Add a Group',
	disableAccess: 'Disable Access',
	members: 'members: {count}',
	addMember: 'Add member',
	accessDenied: 'Access denied',
	search: 'Search',
	max: 'Max',
	min: 'Min',
	open: 'Open',
	months:
	[
		'January',
		'February',
		'March',
		'April',
		'May',
		'June',
		'July',
		'August',
		'September',
		'October',
		'November',
		'December'
	],
	elMessages:
	{
		password_saved: 'Password saved.',
		user_saved: 'User saved.',
		settings_saved: '😎 Settings saved!',
		something_goes_wrong: 'Something goes wrong!',
		element_saved: '👌 Element saved!',
		element_created: 'Element created!',
		element_removed: 'Element removed!',
		cant_create_element: 'Cant create element!',
	},
};
